<template>
    <v-checkbox v-if="!user.terms_of_sale_agreement" dense :dark="dark" @change="updateTermsOfSaleAgreement"
                v-model="termsOfSale" :ripple="false">
        <template slot="label">
                    <span :class="{'--dark': dark}">
                        I agree with the <a @click.prevent="openLink" :href="url" target="_blank">terms and conditions</a> of the service
                    </span>
        </template>
    </v-checkbox>
</template>

<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            termsOfSale: false,
            url: "https://fylm.ai/terms-of-service/"
        }
    },

    props: {
        dark: Boolean
    },

    computed: {
        ...mapState('User', ['user'])
    },

    methods: {
        async updateTermsOfSaleAgreement() {
            this.$emit('change', this.termsOfSale);
            await this.$store.dispatch("User/updateTermsOfSaleAgreement", this.termsOfSale);
        },

        openLink() {
            window.open(this.url, '_blank');
        }
    }
}
</script>

<style lang="scss" scoped>
.v-input {
  span {
    font-size: 12px;
      line-height: 1.2;

    &.--dark {
      color: white;
    }
  }
}
</style>